import { useMicBlockedStore } from '@modules/phone/store/mic-blocked.store';
import MicPermissionModal from './modal-mic-permisssion';

export const MicBlockedModal = () => {
  const { isOpen, close } = useMicBlockedStore();

  return <MicPermissionModal open={isOpen} onClose={close} />;
};
